/**
 * Espelha CriarOportunidadeVendaRequest do OrquestradorVendas (POST ProcessoVenda/idVenda/{idVenda}/oportunidade/nova):
 * "Criar oportunidade" a partir do documento. O cliente é o do documento e a etapa é a primeira do CRM.
 */
export class CriarOportunidadeVendaRequest {
  public titulo: string;
  /** Vendedor do cadastro de Pessoa: ativo e no escopo de quem cria (o orquestrador confere). */
  public idVendedorResponsavel: number;
  /** O CRM exige a origem do lead. */
  public idOrigemLead: number;
}
